import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { setExperiment } from "../../shared/ab-experiment/actions";
import LocationPickerWithMapV2 from "../location-picker-with-map-v2/component";
import { fetchSlots, updateGeoDetailsInLead } from "../pre-delivery-inspection/actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchSlotsConnect: fetchSlots,
    updateGeoDetailsInLeadConnect: updateGeoDetailsInLead,
    setExperimentConnect: setExperiment
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationPickerWithMapV2));
